// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.decorationsServices__container {
  width: 100%;
  margin: 2rem 0;
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
}

.decorationsServices__title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.decorationsServices__title img {
  margin-left: 0.25rem;
  width: 1rem;
}

.decorationsServices__servicesMoreInfo img,
.decorationsServices__servicesBox img {
  width: 1rem;
  margin-left: 0.5rem;
}

.decorationsServices__dest,
.decorationsServies__radioInputContainer {
  display: flex;
  /* margin-top: 1.25rem; */
  align-items: center;
  justify-content: space-between;
}

.decorationServices__selections > div {
  display: flex;
  flex-wrap: wrap;
}
.decorationServices__selections > div .radio-container {
  margin: 0.5rem 0;
}

.decorationsServices__dest .inputLabelFloat:nth-of-type(2) {
  margin: 0 1rem;
}

.decorationsServices__dest {
  margin-top: 2rem;
}

.decorationsServies__radioInputContainer .radio.radio-services {
  border: 1px solid var(--clr-error-dark);
}
.decorationsServies__radioInputContainer .radio.selected {
  border: none;
}

.decorationsServices__servicesBox {
  grid-column: span 2;
}

.decorationsServices__servicesBox label {
  margin-bottom: 0.75rem;
}

.decorationsServices__servicesMoreInfo,
.decorationsServices__servicesBoxMoreInfo {
  position: relative;
  margin-top: 0.25rem;
}

.decorationsServices__servicesMoreInfo span,
.decorationsServices__servicesBoxMoreInfo span {
  position: absolute;
  width: 18rem;
  text-align: center;
  font-size: 0.75rem;
  background: var(--clr-gray800);
  z-index: 10;
  color: #fff;
  padding: 1em;
  border-radius: 1em;
  line-height: 1.5;
  bottom: 50%;
  left: 2rem;
  right: calc(100% - 5rem);
  left: unset;
  transform: translateY(105%);
  /* display: flex; */
  display: none;
}

.decorationsServices__servicesMoreInfo img:hover + span,
.decorationsServices__servicesBoxMoreInfo img:hover + span {
  display: flex;
}

.radio-container {
  width: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.radio-input {
  display: none;
}

.radio-input:checked ~ .radio {
  border: 0.5rem solid var(--clr-primary);
}

.radio {
  max-width: 1.75rem;
  width: 100%;
  border-radius: 50%;
  margin-right: 0.5rem;
  height: 1.75rem;
  background: var(--clr-gray);
}

.decorationsServices__counterContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 8rem;
}

.decorationsServices__attention {
  color: var(--clr-error-dark);
  margin-top: 1rem;
  display: block;
}

.decorationsServices__counter {
  display: flex;
  width: 100%;
  max-width: 7rem;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
}

.decorationsServices__counter span {
  font-weight: bolder;
}

.decorationsServices__dropdownItems,
.decorationsServices__input {
  padding: 1.25em 1.5em;
  border-radius: 1em;
  width: 100%;
  border: none;
  outline: none;
  background: var(--clr-gray300);
  border: 0.15rem solid transparent;
}

.decorationsServices__inputContainer {
  position: relative;
}

.decorationsServices__input:focus {
  border: 0.15rem solid var(--clr-dark);
  background: var(--clr-light);
}

.decorationsServices__inputContainer.read-only input {
  cursor: pointer;
}

.decorationsServices__inputContainer.read-only input:focus {
  background: var(--clr-gray300);
  border: 0.15rem solid transparent;
}

.decorationsServices__dropdownItems {
  padding: 0;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 0.5rem);
  z-index: 1;
  box-shadow: 0 0.5rem 1rem #0004;
}

.decorationsServices__dropdownItems li {
  padding: 1em 1.5em;
  font-size: 0.9rem;
}

.decorationsServices__dropdownItems li:hover {
  background: #e9e9ed;
  cursor: pointer;
}

.decorationsServices__inputClose {
  display: flex;
  right: 1rem;
  width: 1rem;
  cursor: pointer;
  pointer-events: all;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}

.decorationsServices__input:focus ~ .decorationsServices__inputClose {
  pointer-events: all;
  display: flex;
}

.decorationsServices__input:placeholder-shown
  ~ .decorationsServices__inputClose {
  display: none;
  pointer-events: none;
}

.decorationsServices__title span {
  display: grid;
  place-items: flex-end;
  color: var(--clr-gray500);
  font-size: 0.9rem;
  margin-left: auto;
}

@media (min-width: 768px) {
  .decorationsServices__container > div:first-of-type {
    grid-column: span 2;
  }

  .decorationServices__selections > div {
    flex-wrap: nowrap;
  }

  .decorationServices__selections > div .radio-container {
    margin: 0;
  }
}

@media (min-width: 992px) {
  .decorationsServices__servicesMoreInfo span,
  .decorationsServices__servicesBoxMoreInfo span {
    left: 2rem;
    transform: translateY(50%);
    right: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DecorationComponents/DecorationsServices/DecorationsServices.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,0BAA0B;IAC1B,YAAY;EACd;AACF","sourcesContent":[".decorationsServices__container {\n  width: 100%;\n  margin: 2rem 0;\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n}\n\n.decorationsServices__title {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.decorationsServices__title img {\n  margin-left: 0.25rem;\n  width: 1rem;\n}\n\n.decorationsServices__servicesMoreInfo img,\n.decorationsServices__servicesBox img {\n  width: 1rem;\n  margin-left: 0.5rem;\n}\n\n.decorationsServices__dest,\n.decorationsServies__radioInputContainer {\n  display: flex;\n  /* margin-top: 1.25rem; */\n  align-items: center;\n  justify-content: space-between;\n}\n\n.decorationServices__selections > div {\n  display: flex;\n  flex-wrap: wrap;\n}\n.decorationServices__selections > div .radio-container {\n  margin: 0.5rem 0;\n}\n\n.decorationsServices__dest .inputLabelFloat:nth-of-type(2) {\n  margin: 0 1rem;\n}\n\n.decorationsServices__dest {\n  margin-top: 2rem;\n}\n\n.decorationsServies__radioInputContainer .radio.radio-services {\n  border: 1px solid var(--clr-error-dark);\n}\n.decorationsServies__radioInputContainer .radio.selected {\n  border: none;\n}\n\n.decorationsServices__servicesBox {\n  grid-column: span 2;\n}\n\n.decorationsServices__servicesBox label {\n  margin-bottom: 0.75rem;\n}\n\n.decorationsServices__servicesMoreInfo,\n.decorationsServices__servicesBoxMoreInfo {\n  position: relative;\n  margin-top: 0.25rem;\n}\n\n.decorationsServices__servicesMoreInfo span,\n.decorationsServices__servicesBoxMoreInfo span {\n  position: absolute;\n  width: 18rem;\n  text-align: center;\n  font-size: 0.75rem;\n  background: var(--clr-gray800);\n  z-index: 10;\n  color: #fff;\n  padding: 1em;\n  border-radius: 1em;\n  line-height: 1.5;\n  bottom: 50%;\n  left: 2rem;\n  right: calc(100% - 5rem);\n  left: unset;\n  transform: translateY(105%);\n  /* display: flex; */\n  display: none;\n}\n\n.decorationsServices__servicesMoreInfo img:hover + span,\n.decorationsServices__servicesBoxMoreInfo img:hover + span {\n  display: flex;\n}\n\n.radio-container {\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n}\n\n.radio-input {\n  display: none;\n}\n\n.radio-input:checked ~ .radio {\n  border: 0.5rem solid var(--clr-primary);\n}\n\n.radio {\n  max-width: 1.75rem;\n  width: 100%;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  height: 1.75rem;\n  background: var(--clr-gray);\n}\n\n.decorationsServices__counterContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 8rem;\n}\n\n.decorationsServices__attention {\n  color: var(--clr-error-dark);\n  margin-top: 1rem;\n  display: block;\n}\n\n.decorationsServices__counter {\n  display: flex;\n  width: 100%;\n  max-width: 7rem;\n  gap: 0.5rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.decorationsServices__counter span {\n  font-weight: bolder;\n}\n\n.decorationsServices__dropdownItems,\n.decorationsServices__input {\n  padding: 1.25em 1.5em;\n  border-radius: 1em;\n  width: 100%;\n  border: none;\n  outline: none;\n  background: var(--clr-gray300);\n  border: 0.15rem solid transparent;\n}\n\n.decorationsServices__inputContainer {\n  position: relative;\n}\n\n.decorationsServices__input:focus {\n  border: 0.15rem solid var(--clr-dark);\n  background: var(--clr-light);\n}\n\n.decorationsServices__inputContainer.read-only input {\n  cursor: pointer;\n}\n\n.decorationsServices__inputContainer.read-only input:focus {\n  background: var(--clr-gray300);\n  border: 0.15rem solid transparent;\n}\n\n.decorationsServices__dropdownItems {\n  padding: 0;\n  overflow: hidden;\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  z-index: 1;\n  box-shadow: 0 0.5rem 1rem #0004;\n}\n\n.decorationsServices__dropdownItems li {\n  padding: 1em 1.5em;\n  font-size: 0.9rem;\n}\n\n.decorationsServices__dropdownItems li:hover {\n  background: #e9e9ed;\n  cursor: pointer;\n}\n\n.decorationsServices__inputClose {\n  display: flex;\n  right: 1rem;\n  width: 1rem;\n  cursor: pointer;\n  pointer-events: all;\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n}\n\n.decorationsServices__input:focus ~ .decorationsServices__inputClose {\n  pointer-events: all;\n  display: flex;\n}\n\n.decorationsServices__input:placeholder-shown\n  ~ .decorationsServices__inputClose {\n  display: none;\n  pointer-events: none;\n}\n\n.decorationsServices__title span {\n  display: grid;\n  place-items: flex-end;\n  color: var(--clr-gray500);\n  font-size: 0.9rem;\n  margin-left: auto;\n}\n\n@media (min-width: 768px) {\n  .decorationsServices__container > div:first-of-type {\n    grid-column: span 2;\n  }\n\n  .decorationServices__selections > div {\n    flex-wrap: nowrap;\n  }\n\n  .decorationServices__selections > div .radio-container {\n    margin: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .decorationsServices__servicesMoreInfo span,\n  .decorationsServices__servicesBoxMoreInfo span {\n    left: 2rem;\n    transform: translateY(50%);\n    right: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
